import { extendTheme } from "@chakra-ui/react"

export default extendTheme({
  colors: {
    brand: {
      theme: "#EE827D",
      text: "#A52A2A",
      // ヘッダー背景。themeより淡くしてbrand.textの文字を載せる
      headerBg: "#FBD5D0",
    },
  },
  styles: {
    global: {
      body: {
        fontFamily:
          "Yusei Magic, 游明朝, YuMincho, Hiragino Mincho ProN W3, ヒラギノ明朝 ProN W3, Hiragino Mincho ProN, HG明朝E, ＭＳ Ｐ明朝, ＭＳ 明朝, serif",
      },
    },
  },
})
